export function extendPromise(promise, source) {
  const newPromise = promise.then(
    (result) => Object.assign(result, source)
  );
  const withoutPromise = Object.assign({}, promise);
  for (const key of Object.getOwnPropertyNames(
    Promise.prototype
  )) {
    delete withoutPromise[key];
  }
  return Object.assign(newPromise, Object.assign(withoutPromise, source));
}
